import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

export const SET_PROGRAMARI = 'SET_PROGRAMARI'
export const DELETE_PROGRAMARE = 'DELETE_PROGRAMARE'
export const ACCEPTARE_PROGRAMARE = 'ACCEPTARE_PROGRAMARE'
export const ADD_PROGRAMARE = 'ADD_PROGRAMARE'
export const EDIT_PROGRAMARE = 'EDIT_PROGRAMARE'

Vue.use(VueMoment, {
  moment
})

export default {
  [SET_PROGRAMARI] (state, payload) {
    state.programari = []
    Object.values(payload).forEach(function (programareNode) {
      state.programari.push({
        title: programareNode.title[0].value,
        nid: programareNode.nid[0].value,
        idMedic: !(programareNode.field_p_medic == '')
          ? programareNode.field_p_medic[0].target_id
          : '',
        uuidMedic: !(programareNode.field_p_medic == '')
          ? programareNode.field_p_medic[0].target_uuid
          : '',
        idPacient: !(programareNode.field_p_pacient == '')
          ? programareNode.field_p_pacient[0].target_id
          : '',
        uuidPacient: !(programareNode.field_p_pacient == '')
          ? programareNode.field_p_pacient[0].target_uuid
          : '',
        status: programareNode.field_p_status[0].value,
        color: (programareNode.field_p_status == '')
          ? 'cyan'
          : (programareNode.field_p_status[0].value === 'p1')
            ? 'orange'
            : (programareNode.field_p_status[0].value === 'p2')
              ? 'green'
              : (programareNode.field_p_status[0].value === 'p3')
                ? 'red'
                : (programareNode.field_p_status[0].value === 'p4')
                  ? 'blue-grey'
                  : (programareNode.field_p_status[0].value === 'p5')
                    ? 'red accent-4'
                    : (programareNode.field_p_status[0].value === 'p6')
                      ? 'green accent-4'
                      : 'cyans',
        startProgramare: !(programareNode.field_p_data == '')
          ? moment(programareNode.field_p_data[0].value).format('YYYY-MM-DD HH:mm')
          : '',
        endProgramare: !(programareNode.field_p_data_end == '')
          ? moment(programareNode.field_p_data_end[0].value).format('YYYY-MM-DD HH:mm')
          : moment(programareNode.field_p_data[0].value).add(15, 'minute').format('YYYY-MM-DD HH:mm'),
        service: !(programareNode.field_p_service == '')
          ? programareNode.field_p_service[0].value
          : '',
        anulareN: (programareNode.field_motiv_anulare == '')
          ? ''
          : (programareNode.field_motiv_anulare[0].value === 'm1')
            ? 'M-am razgandit'
            : (programareNode.field_motiv_anulare[0].value === 'm2')
              ? 'O sa reprogramez'
              : (programareNode.field_motiv_anulare[0].value === 'm3')
                ? 'Alte motive'
                : 'Personal',
        mention: !(programareNode.field_p_mentions == '')
          ? programareNode.field_p_mentions[0].value
          : '',
        anulare: !(programareNode.field_motiv_anulare == '')
          ? programareNode.field_motiv_anulare[0].value
          : ''
      })
    })
  },
  [DELETE_PROGRAMARE] (state, { nid }) {
    state.dprogramare.push({ nid })
  },
  [ACCEPTARE_PROGRAMARE] (state, { nid }) {
    state.aprogramare.push({ nid })
  },
  [ADD_PROGRAMARE] (state, { title }) {
    state.programare.push({ title })
  },
  [EDIT_PROGRAMARE] (state, { nid }) {
    state.eprogramare.push({ nid })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/programari/ProgramariMutations.js